import { MediaDataRoomVersion } from "features/mediaDataRoom/models";
import { useSafeContext } from "hooks";
import {
  type MediaDataRoomInsightsDataAbContextValue,
  MediaDataRoomInsightsDataContext,
  type MediaDataRoomInsightsDataContextHook,
} from "./models";

export { default as MediaDataRoomInsightsDataAbWrapper } from "./ab/MediaDataRoomInsightsDataAbWrapper";
export {
  type DatasetLeafName,
  MediaDataRoomInsightsDataContext,
  type PublisherDataReportResult,
} from "./models";
export { default as MediaDataRoomInsightsDataV3Wrapper } from "./v3/MediaDataRoomInsightsDataV3Wrapper";

export const useMediaDataRoomInsightsData = ((version) => {
  const contextValue = useSafeContext(MediaDataRoomInsightsDataContext);
  if (version && contextValue.version !== version) {
    throw new Error(
      `Version mismatch. Expected ${version} but got ${contextValue.version}`
    );
  }
  if (version === MediaDataRoomVersion.ab) {
    return contextValue as MediaDataRoomInsightsDataAbContextValue;
  }
  return contextValue;
}) as MediaDataRoomInsightsDataContextHook;
